// extracted by mini-css-extract-plugin
module.exports = {"root":"ScheduleSection_root__5Wa3Q"};